import { useEffect } from "react";
import { Navigate } from "react-router-dom";

/**
 * /contact is not a standalone page — the inquiry form lives on the homepage.
 * We redirect to /#contact so the homepage scrolls to the form section.
 * Using <Navigate replace> means /contact never stays in browser history.
 */
export default function ContactRedirect() {
  useEffect(() => {
    document.title = "Contact · Coumba Kandji Diamonds";
  }, []);
  return <Navigate to="/#contact" replace />;
}
